export type StockValue = number | Record<string, number> | undefined | null;

export function getStock(stock: StockValue, size?: string): number {
  if (stock === undefined || stock === null) return 0;
  if (typeof stock === "number") return stock;
  if (typeof stock === "object") {
    if (size) return stock[size] ?? 0;
    return Object.values(stock).reduce((a, b) => a + (Number(b) || 0), 0);
  }
  return 0;
}

export function normalizeStock(stock: unknown): number | Record<string, number> {
  if (typeof stock === "number") return stock;
  if (stock && typeof stock === "object" && !Array.isArray(stock)) {
    const entries = Object.entries(stock as Record<string, unknown>).filter(
      ([, v]) => typeof v === "number"
    );
    if (entries.length > 0) return Object.fromEntries(entries) as Record<string, number>;
  }
  return 0;
}

export function isOutOfStock(stock: StockValue, size?: string): boolean {
  return getStock(stock, size) <= 0;
}
